import * as React from "react";

import { TopicData } from "@/shared/state/visualization";

/**
 * Returns a function that checks if a given TopicData is a duplicate
 * of an existing message path in the raw message panel.
 */
export function useIsDuplicateMessagePath(messagePaths: TopicData[]) {
  return React.useMemo(() => {
    const existingIds = new Set(
      messagePaths.map((data) => data.messagePath.id),
    );
    return (nextTopicData: TopicData) =>
      existingIds.has(nextTopicData.messagePath.id);
  }, [messagePaths]);
}
